<!--
  Simulation form — designed to fit a 560px-wide preview-options dialog
  without internal scroll. Layout:
    Row 1: Simulation toggle (compact, in-line with hint)
    Row 2: Sample size (full width)
    Row 3: Duration Mean | Unit  +  Jitter %         ← 3 columns
    Row 4: Failure Rate  +  Drift Offset | Unit      ← 3 columns
    Row 5: Reset button
  Section labels collapsed to per-field labels; the verbose hint copy moved
  into mat-hint single lines so the form-field subscript reservation only
  takes ~18px instead of ~38px per row.
-->
<form [formGroup]="form" class="sim-form">

    <div class="sim-row sim-toggle-row">
        <mat-slide-toggle [formControl]="enabled" color="primary">
            Simulation
        </mat-slide-toggle>
        <span class="sim-hint">Local-only — feeds the Gantt preview only.</span>
    </div>

    <div class="sim-disabled-note" *ngIf="enabled.value === false">
        Simulation off — Gantt shows raw events with no duration overrides.
    </div>

    <!-- Sample size — full-width row. Always meaningful (controls how many
         upcoming events to fetch from the calculator), independent of the
         enabled toggle. -->
    <mat-form-field appearance="outline" class="sim-full">
        <mat-label>Sample size — number of events</mat-label>
        <input matInput type="number" [formControl]="sampleSize" min="1" max="500"
               matTooltip="Each event is one calculator iteration. Higher = longer-range preview, slower refresh. 10–50 daily, 50–200 hourly.">
        <mat-hint>1–500. Default 10.</mat-hint>
    </mat-form-field>

    <ng-container *ngIf="enabled.value !== false">

        <!-- Duration Mean + Unit + Jitter — three-column row. -->
        <div class="sim-row-3col">
            <mat-form-field appearance="outline">
                <mat-label>Bar duration</mat-label>
                <input matInput type="number" [formControl]="durationValue" min="0"
                       matTooltip="How long each execution paints on the Gantt. 0 = point markers (no width).">
            </mat-form-field>
            <mat-form-field appearance="outline" class="sim-unit-narrow">
                <mat-label>Unit</mat-label>
                <mat-select [formControl]="durationUnit">
                    <mat-option value="seconds">sec</mat-option>
                    <mat-option value="minutes">min</mat-option>
                    <mat-option value="hours">hour</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Jitter</mat-label>
                <span matTextSuffix>&nbsp;%</span>
                <input matInput type="number" [formControl]="jitterPercent" min="0" max="100"
                       matTooltip="Randomly varies the duration by ± this percent. 0 = every bar exactly the mean.">
            </mat-form-field>
        </div>

        <!-- Failure rate + Drift offset + Drift unit — three-column row. -->
        <div class="sim-row-3col">
            <mat-form-field appearance="outline">
                <mat-label>Failure rate</mat-label>
                <span matTextSuffix>&nbsp;%</span>
                <input matInput type="number" [formControl]="failurePercent" min="0" max="100"
                       matTooltip="% of executions painted red. 0 = all succeed · 100 = all fail.">
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Start drift</mat-label>
                <input matInput type="number" [formControl]="driftValue"
                       matTooltip="Offset added to every event's start. Negative = early.">
            </mat-form-field>
            <mat-form-field appearance="outline" class="sim-unit-narrow">
                <mat-label>Unit</mat-label>
                <mat-select [formControl]="driftUnit">
                    <mat-option value="seconds">sec</mat-option>
                    <mat-option value="minutes">min</mat-option>
                    <mat-option value="hours">hour</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Reset button moved into the dialog footer (next to Cancel /
             Apply). The form keeps just the inputs; chrome lives on the
             dialog shell. -->

    </ng-container>
</form>
